export enum Types {
  ADD_NOTIFICATIONS = 'notifications/ADD_NOTIFICATIONS',
  REMOVE_NOTIFICATIONS = 'notifications/REMOVE_NOTIFICATIONS'
}

export interface INotificationsState {
  newContractNotifications?: INewContractNotification[];
}

export interface INotification {
  title: string;
  type: ENotificationTypes;
  id?: string;
}

export interface INewContractNotification extends INotification {
  customerId: string;
}

export enum ENotificationTypes {
  NEW_CONTRACT = 'NEW_CONTRACT'
}
